<template>
    <div class="mt-4">
        <div class="col-7 pt-4 float-left">
            <mercur-checkbox v-model="value.active">Active</mercur-checkbox>
            <pretty-select v-model="value.productType" :options="['photo', 'logo']" placeholder="Product Type"></pretty-select>
            <mercur-checkbox v-model="value.vectorization">Vectorization</mercur-checkbox>
            <mercur-input v-model="value.bleed" type="number" min="0" step="any">Bleed</mercur-input>
        </div>
    </div>
</template>
<script>

import PrettySelect from '@/components/utils/PrettySelect.vue'

export default {
    name: 'CatalogProductSettingFastEditor',
    components: { PrettySelect },
    props: {
        value: {
            type: Object,
            default: () => ({
                active: false,
                productType: '',
                vectorization: false,
                bleed: 0,
            }),
        },
    },
    watch: {
        'value.bleed': {
            handler (newVal) {
                if (newVal === '' || newVal === null) {
                    this.value.bleed = 0
                } else {
                    const parsed = parseFloat(newVal)
                    if (!isNaN(parsed) && this.value.bleed !== parsed) {
                        this.value.bleed = parsed
                    }
                }
            },
            immediate: false,
        },
    },
}
</script>
<style scoped lang="scss">
.float-left {
    float: left;
    margin-left: -13px;
}
.d-inline-block+.d-inline-block {
    margin-left: 15px;
}
</style>
